export default (res, ...params) => {
  // eslint-disable-next-line no-console
  console.log(...params, res);
  return res;
};
